import { ArtifactsService } from '@inference.engine/api-client/web';
import { inferenceHttp } from '@/lib/api/http-client';

/**
 * Reads the self-contained snapshot stored on a saved (context-less) artifact
 * by id. Saved artifacts freeze a copy of their source's render data into
 * `artifact.data` at save time, so the Library renders them without the live
 * source still existing — and the workspace-api detail path can't enrich a
 * null-context artifact, so the snapshot is read straight from the inference-api
 * here.
 *
 * The single generic fetcher behind saved-kind previews (strategy, ideation, …);
 * callers cast the returned `data` to their kind's snapshot type. Note: other
 * ENTITIES can't import this (cross-entity value imports are forbidden) — the
 * opportunity entity keeps its own inline copy.
 */
export const getSavedArtifactSnapshot = async <T>(
  workspaceId: string,
  artifactId: string,
): Promise<T> => {
  const response = await ArtifactsService.getWorkspaceArtifactById({
    client: inferenceHttp,
    path: { workspaceId, artifactId },
  });

  if (!response.data) {
    throw new Error('No data returned from workspace artifact API');
  }

  return response.data.data as T;
};
